module.exports = __webpack_public_path__ + "img/baac.3798d039.svg";